import script from "./ProcedureHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureHeader.vue?vue&type=script&setup=true&lang=js"

import "./ProcedureHeader.vue?vue&type=style&index=0&id=1113bc70&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1113bc70"]])

export default __exports__